import React from 'react';
import Select from '@mui/material/Select';
import classNames from 'classnames';

export default function SelectInput({ id, value, handleChange, children, className, ...props }) {
    const selectClasses = classNames(className, 'wcf-ui-select-input-container');

    return (
        <Select
            id={id}
            value={value}
            onChange={handleChange}
            className={selectClasses}
            IconComponent={(props) => <span {...props} className={props.className + ' stw-expand-general'}></span>}
            {...props}
        >
            {children}
        </Select>
    );
}
